// extracted by mini-css-extract-plugin
export default {"HomePage":"HomePage_HomePage__64QZo","TopContainer":"HomePage_TopContainer__dbYot","BackgroundImg":"HomePage_BackgroundImg__mhmst","UserContainer":"HomePage_UserContainer__Nek+s"};